var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedDyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 86,
    fill: "none",
    viewBox: "0 0 39 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#868CA6",
    d: "M13.04 85.58c-.888 0-2.245-.326-2.993-.558-.749-.234-1.357-2.936-1.357-2.936-1.964-7.64-4.624-18.882-4.684-25.659-.012-1.343 0-27.427 0-27.427H22.057v27.427c0 7-3.122 18.02-5.087 25.66 0 0-.608 2.701-1.356 2.934-.749.233-2.105.56-2.994.56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0C3D2",
    d: "M12.986 84.641c-.795 0-2.011-.279-2.666-.512-.655-.186-1.216-2.655-1.216-2.655-1.778-6.849-3.58-16.945-4.095-22.955V30.427h16.045s.281 24.924 0 28.092c-.514 6.01-2.735 16.06-4.513 22.908 0 0-.56 2.422-1.216 2.655-.655.187-1.871.513-2.666.513",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#868CA6",
    d: "M2 29h23.066v2H2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF2727",
    d: "M12.986 84.641c-.795 0-2.011-.28-2.666-.512-.655-.186-1.216-2.656-1.216-2.656-1.778-6.848-3.58-16.944-4.095-22.954V55h16.045v3.519c-.514 6.01-2.735 16.06-4.513 22.908 0 0-.56 2.422-1.216 2.655-.655.187-1.871.513-2.666.513",
    opacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M17.043 31h5.014v26.51c0 2.945-2.005 12.272-2.005 12.272s-3.793 14.512-4.012 14.727c-.22.215-3.008.491-3.008.491l4.01-27.49V31z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#AFB3C5",
    d: "M35.25 6.477l-5.18 15.139-3.472-1.189 5.18-15.138z",
    opacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#868CA6",
    fillRule: "evenodd",
    d: "M30.498 27.064l8.356-24.416L36.962 2l-8.419 24.6.033.01c-.402.774-1.032 1.372-1.716 1.782-.713.428-1.412.608-1.86.608v2c.885 0 1.936-.32 2.89-.892.966-.58 1.905-1.462 2.504-2.66a.997.997 0 0 0 .104-.384z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDyeOpen);
export default __webpack_public_path__ + "static/media/RedDye-open.fbdbeccf31737d45b9262b0b37f3c9e6.svg";
export { ForwardRef as ReactComponent };